(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["magnesio-gallery"] && !Shopify.designMode) return;
  try {
    function initializeMagnesioGalleries(scope = document) {
  scope.querySelectorAll('[data-mg-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-mg-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-mg-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-mg-gallery-thumb]'));
    const counter = gallery.querySelector('[data-mg-gallery-count]');
    if (slides.length < 2) return;
    let index = 0;
    let frame;
    function update() {
      const bounds = track.getBoundingClientRect();
      let distance = Infinity;
      slides.forEach((slide, current) => {
        const offset = Math.abs(slide.getBoundingClientRect().left - bounds.left);
        if (offset < distance) { distance = offset; index = current; }
      });
      thumbs.forEach((thumb, current) => thumb.setAttribute('aria-current', String(current === index)));
      counter.textContent = `${index + 1} / ${slides.length}`;
    }
    function goTo(next) {
      index = (next + slides.length) % slides.length;
      const left = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    gallery.querySelector('[data-mg-gallery-prev]').addEventListener('click', () => goTo(index - 1));
    gallery.querySelector('[data-mg-gallery-next]').addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((thumb, current) => thumb.addEventListener('click', () => goTo(current)));
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      if (event.key === 'Home') { event.preventDefault(); goTo(0); }
      if (event.key === 'End') { event.preventDefault(); goTo(slides.length - 1); }
    });
    update();
  });
}
initializeMagnesioGalleries();
document.addEventListener('shopify:section:load', event => initializeMagnesioGalleries(event.target));
  } catch(e) { console.error(e); }
})();

})();
